import * as Sentry from '@sentry/react';

const GLOBAL_PREFIX = 'BreathLab Error';

interface AppLogger {
  error(message: string, cause?: unknown): void;
}

export function createLogger(modulePrefix: string): AppLogger {
  return {
    error(message, cause) {
      const tag = `[${GLOBAL_PREFIX}][${modulePrefix}] ${message}`;
      Sentry.withScope((scope) => {
        scope.setExtra('context', tag);
        if (cause instanceof Error) {
          Sentry.captureException(cause);
        } else {
          Sentry.captureMessage(tag, 'error');
        }
      });
      if (import.meta.env.DEV) console.error(tag, cause);
    },
  };
}
